import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../redux/store/appStore';
import { getConfig, setCreateConfigStatus, setUpdateConfigStatus, updateConfigData } from '../../redux/slices/config';
import DictTypeContent from './dictTypeContent';
import ListTypeContent from './listTypeContent';
import ChipList from './chipList';
import JsonTypeContent from './jsonTypeContent';
import { Typography, CircularProgress, FormControl, Select, MenuItem, InputLabel, Chip, Box, Tooltip } from '@mui/material';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { getProject } from '../../redux/slices/projectSlice/addProjectSlice';
import { STATUS } from '../../utils/status';
import SnackbarNotification from '../snackbar/snackbarNotification';
import getAuthToken from '../../utils/authToken';
import { constants } from '../../utils/constants';
import { getReview } from '../../redux/slices/reviewerSlice';

export interface ConfigIds {
  id: string;
  identifier: string;
  name: string;
  config_details: {
    id: number;
    name: string;
    value: string;
    type: string;
  };
  stage_id: number | null;
  type: 'TASK' | 'REVIEW';
  value?: Record<string, unknown>;
}

interface ConfigFormInterface {
  onAddConfigClick?: any;
}

const Config: React.FC<ConfigFormInterface> = () => {
  const [selectedChip, setSelectedChip] = useState<string | null>(null);
  const [listFields] = useState<string[]>([]);
  const [clickedChip, setClickedChip] = useState<{ id: string; name: string, interactive_config: boolean } | null>(null);
  const [initialSelectionDone, setInitialSelectionDone] = useState(false);
  const dispatch = useDispatch<AppDispatch>();
  const configData = useSelector((state: RootState) => state.config.config);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [dictFields, setDictFields] = useState<{ [key: string]: string }>({});
  const { id } = useParams();
  const path = window.location.href.includes('test')
  const editPath = window.location.href.includes('editconfig')
  const navigate = useNavigate();
  const fetchedProject = useSelector((state: RootState) => state.projects.project);
  const task_category = fetchedProject.task_category_id && fetchedProject.task_category_id;
  const createStatus = useSelector((state: RootState) => state.config.createStatus);
  const updateStatus = useSelector((state: RootState) => state.config.updateStatus);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState<'success' | 'error' | 'info' | 'warning'>('success');
  const getConfigStatus = useSelector((state: RootState) => state.config.getStatus)
  const getConfigCategpryListStatus = useSelector((state: RootState) => state.config.getConfigCategoryListStatus)
  const selectedStageId = useSelector((state: RootState) => state.reviewStage.selectedStageId);
  let { configRowId } = useParams()
  const createConfigMessage = useSelector((state: RootState) => state.config.createConfigMessage)
  const updateConfigMessage = useSelector((state: RootState) => state.config.updateConfigMessage)
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [configIds, setConfigIds] = useState<ConfigIds[]>([]);
  const getReviewStages = useSelector((state: RootState) => state.reviewStage.reviewer);
  const getReviewStatus = useSelector((state: RootState) => state.reviewStage.getReviewStatus);
  const [searchParams] = useSearchParams();
  const selectedStageConfig = searchParams.get("selectedStageConfig");
  const [selectedStage, setSelectedStage] = useState(selectedStageConfig);

  const handleSnackbar = (message: string, severity: 'success' | 'error' | 'info' | 'warning') => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  useEffect(() => {
    if (id) {
      dispatch(getProject({ project_id: id, id: configRowId }));
    }
  }, [id, dispatch]);

  const fetchConfigIds = async () => {
    if (!id) {
      setConfigIds([]);
      setStatus("idle");
      return;
    }

    const token = getAuthToken();
    setStatus("loading");

    try {
      const params = new URLSearchParams({
        paginate: "false",
        project_id: id,
        fields: JSON.stringify(["id", "identifier", "name", "config_details", "stage_id", "type", "value"]),
        type: "TASK,REVIEW",
      });

      if (selectedStage) {
        params.set("stage_id", selectedStage);
      }

      const response = await fetch(
        `${constants.API_BASE_URL.replace(/\/$/, "")}/project/company/config/?` +
        params,
        {
          method: "GET",
          headers: {
            Authorization: "Bearer " + token,
            "Content-type": "application/json",
          },
        }
      );

      if (!response.ok) {
        const errorBody = await response.text();
        console.error("Error fetching config IDs:", response.status, errorBody);
        setStatus("error");
        return;
      }
      const responseData = await response.json();
      const data: Array<{
        id: string;
        identifier: string;
        name: string;
        config_details: {
          id: number;
          name: string;
          value: string;
          type: string;
        };
        stage_id: number | null;
        type: 'TASK' | 'REVIEW';
      }> = Array.isArray(responseData) ? responseData : responseData?.results ?? [];
      setConfigIds(data);

      setStatus("success");
    } catch (error) {
      console.error("Error fetching config IDs:", error);
      setStatus("error");
    }
  };

  useEffect(() => {
    fetchConfigIds();
  }, [id, selectedStage]);

  const updateConfigInStore = (updatedConfigData: any) => {
    dispatch(updateConfigData(updatedConfigData));
  };

  useEffect(() => {
    if (task_category === '') return;

    if (path) {
      dispatch(
        getConfig({
          id,
          task_category,
          category: "TEST",
        })
      );
      return;
    }

    if (selectedCategory || configRowId) {
      dispatch(
        getConfig({
          id,
          task_category,
          category: selectedCategory,
        })
      );
    }
  }, [dispatch, id, task_category, selectedCategory, path]);


  useEffect(() => {
    // if (createStatus === STATUS.SUCESS) {
    //   handleSnackbar(createConfigMessage, 'success');
    //   setTimeout(() => {
    //     path ? navigate(`/project/${id}?tab=test`) : navigate(`/project/${id}?tab=config`);
    //     dispatch(setCreateConfigStatus(STATUS.NOT_STARTED))
    //   }, 2000);

    if (createStatus === STATUS.SUCESS) {
      handleSnackbar(createConfigMessage, 'success');
      setTimeout(() => {
        const createdConfigData = (configData as any)?.data;
        const isUploadConfig = createdConfigData?.config_details?.value === 'upload';
        if (isUploadConfig) {
          const configUuid = createdConfigData?.id;
          const subProjectId = createdConfigData?.sub_project_id;
          const configTypeId = createdConfigData?.config_id;
          window.location.href = `/editconfig/${subProjectId}/${configTypeId}/${configUuid}?selectedStageConfig=${selectedStage}`;
        } else {
          path
            ? navigate(`/project/${id}?tab=test&selectedStageConfig=${selectedStage}`)
            : navigate(`/project/${id}?tab=config&selectedStageConfig=${selectedStage}`);
          dispatch(setCreateConfigStatus(STATUS.NOT_STARTED));
        }
      }, 2000);


    } else if (createStatus === STATUS.FAILED) {
      handleSnackbar(createConfigMessage, 'error');
      setTimeout(() => {
        dispatch(setCreateConfigStatus(STATUS.NOT_STARTED));
      }, 1000);
    }
  }, [createStatus]);

  useEffect(() => {
    if (selectedStage && getReviewStages?.results?.length > 0) {
      const selectedStageObj = getReviewStages.results.find(
        (stage: any) => String(stage.id) === String(selectedStage)
      );
      if (selectedStageObj) {
        setSelectedCategory(selectedStageObj.category || "");
      }
    }
  }, [selectedStage, getReviewStages]);

  useEffect(() => {
    // if (updateStatus === STATUS.SUCESS) {
    //   path ? navigate(`/project/${id}?tab=test`) : navigate(`/project/${id}?tab=config`);
    //   handleSnackbar(updateConfigMessage, 'success');
    //   setTimeout(() => {
    //     dispatch(setUpdateConfigStatus(STATUS.NOT_STARTED));
    //   }, 1000);
    if (updateStatus === STATUS.SUCESS) {
      handleSnackbar(updateConfigMessage, 'success');
      setTimeout(() => {
        const updatedConfigData = (configData as any)?.data;
        const isUploadConfig = updatedConfigData?.config_details?.value === 'upload';
        if (isUploadConfig) {
          const configUuid = updatedConfigData?.id;
          const subProjectId = updatedConfigData?.sub_project_id;
          const configTypeId = updatedConfigData?.config_id;
          window.location.href = `/editconfig/${subProjectId}/${configTypeId}/${configUuid}?selectedStageConfig=${selectedStage}`;
        } else {
          path
            ? navigate(`/project/${id}?tab=test&selectedStageConfig=${selectedStage}`)
            : navigate(`/project/${id}?tab=config&selectedStageConfig=${selectedStage}`);
          dispatch(setUpdateConfigStatus(STATUS.NOT_STARTED));
        }
      }, 1000);

    } else if (updateStatus === STATUS.FAILED) {
      handleSnackbar(updateConfigMessage, 'error');
      setTimeout(() => {
        dispatch(setUpdateConfigStatus(STATUS.NOT_STARTED));
      }, 1000);
    }
  }, [updateStatus]);

  // useEffect(() => {
  //   if (!initialSelectionDone && configData.data && configData.data.length > 0 && path) {
  //     const firstChip = configData.data[0];
  //     setSelectedChip(firstChip && firstChip.value);
  //     setClickedChip({ id: firstChip.id, name: firstChip && firstChip.value, interactive_config: firstChip.interactive_config });
  //     setInitialSelectionDone(true);
  //   }
  // }, [configData, initialSelectionDone, path]);

  useEffect(() => {
    if (!initialSelectionDone && configData?.data && configData.data.length > 0) {
      const firstChip = configData.data[0];
      if (firstChip) {
        setSelectedChip(firstChip.value);
        setClickedChip({ id: firstChip.id, name: firstChip && firstChip.value, interactive_config: firstChip.interactive_config });
        setInitialSelectionDone(true);
      }
    }
  }, [configData?.data, initialSelectionDone]);

  const handleChipClick = (chipLabel: string, chipId: string, chipInteractive: boolean) => {
    setSelectedChip(chipLabel);
    setClickedChip({ id: chipId, name: chipLabel, interactive_config: chipInteractive });
  };

  const handleInputChange = (key: string, value: string) => {
    setDictFields(prevDictFields => ({
      ...prevDictFields,
      [key]: value
    }));
  };

  const handleSubmitJson = (jsonData: Array<{ [key: string]: string }>) => {
    updateConfigInStore({ jsonData });
  };

  const renderChipContent = (chipLabel: string, chipId: string) => {
    if (!configData.data) return null;
    if (!Array.isArray(configData.data)) return null;
    const selectedConfig = configData.data?.find((config: any) => config.value === chipLabel);

    if (!selectedConfig) {
      return null;
    }

    const { type, keys } = selectedConfig;
    switch (type) {
      case 'list':
        return (
          <ListTypeContent
            chipId={chipId || ''}
            chipLabel={chipLabel}
            listFields={listFields}
            keys={keys || null}
            taskCategory={task_category}
            configIds={configIds}
            configStatus={status}
            selectedStage={selectedStage || ''}
            selectedCategory={selectedCategory}
          />
        );

      case 'dict':
        return (
          <DictTypeContent
            chipId={chipId || ''}
            chipLabel={chipLabel}
            keys={keys || null}
            handleInputChange={handleInputChange}
            taskCategory={task_category}
            interactiveConfig={clickedChip?.interactive_config || false}
            configIds={configIds}
            configStatus={status}
            selectedStage={selectedStage || ''}
            selectedCategory={selectedCategory}
          />
        );

      case 'json':
        return (
          <JsonTypeContent
            chipId={chipId || ''}
            chipLabel={chipLabel}
            keys={keys || []}
            handleSubmit={handleSubmitJson}
            taskCategory={task_category}
            configIds={configIds}
            configStatus={status}
            selectedStage={selectedStage || ''}
            selectedCategory={selectedCategory}
          />
        );

      default:
        return null;
    }

  };

  useEffect(() => {
    dispatch(getReview({ project_id: id || "" }));
  }, [dispatch, id]);

  const handleStageOptionChange = (event: any) => {
    const stageId = event.target.value
    const selectedStageObj = getReviewStages?.results?.find(
      (stage: any) => stage.id === stageId
    );
    setSelectedStage(stageId);
    setSelectedCategory(selectedStageObj?.category || "");
    setInitialSelectionDone(false)
    navigate(`?selectedStage=${stageId}`);
  };
  return (
    <>
      <Typography style={{ fontFamily: 'Montserrat', fontSize: '14px', fontWeight: 600, lineHeight: '24px', letterSpacing: '0px', textAlign: 'left', color: '#10383D' }}>
        {path ? 'Select Type of Question' : ``}
      </Typography>
      <div style={{ display: "flex", gap: 0, marginTop: "20px" }}>
        <Typography
          sx={{
            fontFamily: "Montserrat",
            fontSize: "14px",
            fontWeight: 600,
            lineHeight: "24px",
            letterSpacing: "0px",
            textAlign: "left",
            color: "#10383D",
            marginTop: "10px",
            marginRight: "50px",
          }}
        >
          {" "}
          Choose Stage:
        </Typography>

        <FormControl sx={{ width: "260px" }} variant="standard">
          <InputLabel id="demo-simple-select-label">
            <span style={{ fontFamily: "montserrat" }}>Select Stage</span>
          </InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={selectedStage}
            label="Select Stage"
            disabled={editPath}
            style={{ borderRadius: "30px" }}
            onChange={handleStageOptionChange}
          >
            {getReviewStatus === STATUS.SUCESS &&
              getReviewStages?.results?.map((option: any) => {
                return (
                  <MenuItem key={option.id} value={option.id}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        minWidth: "200px",
                      }}
                    >
                      <Tooltip title={option.name} arrow>
                        <span
                          style={{
                            fontFamily: "montserrat",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            maxWidth: "150px",
                            display: "inline-block",
                          }}
                        >
                          {option.name}
                        </span>
                      </Tooltip>

                      <Chip
                        size="small"
                        sx={{
                          fontSize: "11px",
                          backgroundColor: option.category === "REVIEW" ? "#1976d2" : "default",
                          color: option.category === "REVIEW" ? "#ffffff" : "#000000",
                          border: "1px solid #ccc",
                          marginLeft: "10px",
                          flexShrink: 0,
                        }}
                        label={option.category || "Task"}
                      />
                    </Box>
                  </MenuItem>
                );
              })}
          </Select>
        </FormControl>
      </div>
      {(getConfigStatus === STATUS.SUCESS || getConfigCategpryListStatus === STATUS.SUCESS) &&
        <div style={{ marginTop: '10px' }}>
          <div style={{ marginTop: '20px' }}></div>
          <ChipList configData={configData} handleChipClick={handleChipClick} selectedChip={selectedChip} disableChip={!selectedStage} />
          <div style={{ marginTop: '20px' }}></div>
          {selectedChip && clickedChip?.id && renderChipContent(selectedChip, clickedChip.id)}
        </div>
      }
      {getConfigStatus === STATUS.PENDING && <CircularProgress size={30} sx={{ marginTop: '20px' }} />}
      <SnackbarNotification
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleSnackbarClose}
      />
    </>
  );
};

export default Config;
